<template>
  <span v-if="biz === 'list'" :class="['inline-block', computedClass]">{{
    LEAVE_STATUS_TEXT[status]
  }}</span>
  <i
    v-else
    class="font-120 iconfont"
    :style="{ color: computedClass.color }"
    v-html="computedClass.icon"
  ></i>
</template>

<script>
import { LEAVE_STATUS, LEAVE_STATUS_TEXT } from '@/utils/constUtils'
export default {
  name: 'leaveStatus',
  components: {},
  props: {
    border: {
      type: Boolean, // 是否需要边框
      default: false
    },
    status: [String, Number], // 请假状态
    biz: {
      type: String,
      default: 'list'
    }
  },
  data() {
    return {
      LEAVE_STATUS,
      LEAVE_STATUS_TEXT
    }
  },
  computed: {
    computedClass() {
      if (this.biz === 'list') {
        let _result = ''
        switch (this.status) {
          // 待审批/待撤销
          case LEAVE_STATUS.toBeChecked:
          case LEAVE_STATUS.toBeCancel:
            _result = this.border
              ? 'leave-status-checking border-checking'
              : 'leave-status-checking'
            break
          // 已销假
          case LEAVE_STATUS.revoked:
            _result = this.border
              ? 'leave-status-revoked border-revoked'
              : 'leave-status-revoked'
            break
          // 已同意
          case LEAVE_STATUS.agreed:
          case LEAVE_STATUS.cancelRejected:
            _result = this.border
              ? 'leave-status-agreed border-agreed'
              : 'leave-status-agreed'
            break
          // 已拒绝/拒绝撤销
          case LEAVE_STATUS.rejected:
            _result = this.border
              ? 'leave-status-rejected border-rejected'
              : 'leave-status-rejected'
            break
          // 已撤销/已失效
          case LEAVE_STATUS.invalidity:
          case LEAVE_STATUS.canceled:
            _result = this.border
              ? 'leave-status-canceled border-canceled'
              : 'leave-status-canceled'
            break
          default:
            break
        }
        return _result
      } else {
        switch (this.status) {
          // 待审批/待撤销
          case LEAVE_STATUS.toBeChecked: // 1
          case LEAVE_STATUS.toBeCancel: // 4
            return {
              color: '#ff943e',
              icon: '&#xe69d;'
            }
          // 已同意
          case LEAVE_STATUS.agreed: // 2
          case LEAVE_STATUS.cancelRejected: // 6
            return {
              color: '#15bc83',
              icon: '&#xe6a2;'
            }
          // 已拒绝/拒绝撤销
          case LEAVE_STATUS.rejected: // 3
            return {
              color: '#f25643',
              icon: '&#xe6a0;'
            }
          // 已撤销
          case LEAVE_STATUS.canceled: // 5
            return {
              color: 'rgba(23, 26, 29, 0.4)',
              icon: '&#xe69e;'
            }
          // 已失效
          case LEAVE_STATUS.invalidity: // 7
            return {
              color: 'rgba(23, 26, 29, 0.4)',
              icon: '&#xe69f;'
            }
          // 已销假
          case LEAVE_STATUS.revoked: // 8
            return {
              color: '#72D0FB',
              icon: '&#xe7a5;'
            }
          default:
            return {
              color: '',
              icon: ''
            }
        }
      }
    }
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {},
  filters: {}
}
</script>

<style lang="scss" scoped>
.leave-status-checking {
  color: #ff943e;
}
.leave-status-revoked {
  color: #5ac8fa;
}
.leave-status-agreed {
  color: #15bc83;
}
.leave-status-rejected {
  color: #f25643;
}
.leave-status-canceled {
  color: rgba(23, 26, 29, 0.4);
}
.border-checking {
  border: 1px solid rgb(255, 148, 62, 0.5);
  padding: 3px 6px;
  border-radius: 4px;
}
.border-revoked {
  border: 1px solid rgb(90, 200, 250, 0.5);
  padding: 3px 6px;
  border-radius: 4px;
}
.border-agreed {
  border: 1px solid rgb(21, 188, 131, 0.5);
  padding: 3px 6px;
  border-radius: 4px;
}
.border-rejected {
  border: 1px solid rgb(242, 86, 67, 0.5);
  padding: 3px 6px;
  border-radius: 4px;
}
.border-canceled {
  border: 1px solid rgba(23, 26, 29, 0.4);
  padding: 3px 6px;
  border-radius: 4px;
}
</style>
